import { forwardRef, type ComponentProps, type ComponentRef } from 'react';
import clsx from 'clsx';
import { Card as MuiCard } from '@mui/material';

export type RwCardProps = ComponentProps<typeof MuiCard>;

// Wires to rw-ds.css `.rw-card` (rw-ds-components § Card) — flat/borderless/square
// content container. Pair with `RwCardContent`/`RwCardHeader`/`RwCardActionArea`/
// `RwCardActions` (re-exported raw from `@mui/material` in ./index.ts).

export const RwCard = forwardRef<ComponentRef<typeof MuiCard>, RwCardProps>(function RwCard({ className, ...props }, ref) {
  return <MuiCard ref={ref} className={clsx('rw-card', className)} {...props} />;
});
